import cx from 'classnames';
import CountDown from 'components/CountDown/CountDown';
import Checkmark from 'components/Icons/Checkmark';
import DeviceRotate from 'components/Icons/DeviceRotate';
import Measure from 'components/Icons/Measure';
import Tick from 'components/Icons/Tick';
import UIButton from 'components/Others/UIButton';
import UIMobileFullscreenOverlay from 'components/Others/UIMobileFullScreenOverlay';
import UIModal from 'components/Others/UIModal';
import Spinner from 'components/Spinner/Spinner';
import useWindowSize from 'hooks/useWindowSize';
import Image from "next/legacy/image";
import Link from 'next/link';
import useInterval from 'hooks/useInterval';
import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setShowModal, setShowWelcomeScreen, setUseThisPD } from 'redux/features/pd/pdSlice';
import { Transition } from '@headlessui/react';
import * as ga from '../../lib/ga';
import instruction1 from '../../public/pd/intstruction1.png';
import instruction2 from '../../public/pd/intstruction2.png';
import PDCameraView from './PDCameraView';
import Selfie from 'components/Icons/Selfie';
import GlassOff from 'components/Icons/GlassOff';
import Caret from 'components/Icons/Caret';
import Arrow from 'components/Icons/Arrow';
import ArrowAlt from 'components/Icons/ArrowAlt';
import router, { useRouter } from 'next/router';
import Mute from 'components/Icons/Mute';
import UnMute from 'components/Icons/UnMute';
import PlayIcon from 'components/Icons/PlayIcon';
import PlayCircleIcon from 'components/Icons/PlayCircleIcon';
import InfoIcon from 'components/Icons/InfoIcon';
import PDTermsAndConditions from './PDTermsAndConditions';


export interface PDColor {
  title: string;
  hex: string;
  id: string;
  keyword?: string;
  defaultTreatType?: string;
  disabledRegions?: string[];
}

interface PDModalProps {
  description?: string;
  isVisible: boolean;
  // eslint-disable-next-line no-unused-vars
  updateVisibility: (value: boolean) => void;
}

export interface SelectedColorMap {
  frame?: string;
  arm?: string;
  lens?: string;
}

export interface SelectedPDColors {
  frame?: PDColor;
  arm?: PDColor;
  lens?: PDColor;
}

type GlassesModularPart = 'frame' | 'arm' | 'lens';

const PDModal: FC = () => {
  const [lockModal, setLockModal] = useState(false);
  const dispatch = useDispatch()

  const title = `Pupil Distance Calculator`;

  const [isVisible, updateVisibility] = useState(false);
  const showPdModal = useSelector((state: any) => state.pdEvent.showPdModal);

  const updateOverlayVisibility = (value: boolean) => {
    if (value) {
      updateVisibility(value);
      return;
    }
    dispatch(setShowModal(false))
    updateVisibility(value);
  };

  const { width } = useWindowSize();

  const router = useRouter();


  const viewProductClickHandler = () => {
    ga.sendUICustomEvent({
      eventCategory: 'PD',
      eventAction: 'PD Overlay Click',
      eventLabel: 'View Product'
    });
    updateVisibility(false);
  };

  useMemo(() => {
    // console.log("showPdModal", showPdModal)
    if (showPdModal) {
      updateVisibility(true);
    }
    else {
      //dispatch(setShowModal(false))
      updateVisibility(false);
    }
  }, [showPdModal]);

  if (isVisible === false) {
    return null
  }

  return width < 950 ? (
    <PDMobileOverlay
      isVisible={isVisible}
      updateVisibility={updateOverlayVisibility}
      title={title}
      updateLockModal={setLockModal}
      lockModal={lockModal}
      onViewProductClick={() => viewProductClickHandler()}
    />
  ) : (
    <PDDesktopModal
      isVisible={isVisible}
      updateVisibility={updateOverlayVisibility}
      title={title}
      updateLockModal={setLockModal}
      lockModal={lockModal}
      onViewProductClick={() => viewProductClickHandler()}
    />
  );
};
interface PDOverlayProps {
  title: string;
  isVisible: boolean;
  // eslint-disable-next-line no-unused-vars
  updateVisibility: (value: boolean) => void;
  lockModal: boolean;
  // eslint-disable-next-line no-unused-vars
  updateLockModal: (value: boolean) => void;
  minPrice?: number;
  onViewProductClick?: () => void;
}

const PDDesktopModal: FC<PDOverlayProps> = ({
  isVisible,
  updateVisibility,
  title,
  lockModal,
  updateLockModal,
  onViewProductClick,
  minPrice
}) => {


  const calculatedPd = useSelector((state: any) => state.pdEvent.calculatedPd);
  const centerToIris = useSelector((state: any) => state.pdEvent.centerToIris);
  const headSize = useSelector((state: any) => state.pdEvent.headSize);
  const isTooFar = useSelector((state: any) => state.pdEvent.faceIsTooFar)
  const straight = useSelector((state: any) => state.pdEvent.faceIsStraight);

  const dispatch = useDispatch()
  const cam = useRef()
  const [refresh, doRefresh] = useState(0);
  const [isCalculating, setIsCalculating] = useState(false);
  const [cpKey, setCpKey] = useState(0);
  const showResult = useSelector((state: any) => state.pdEvent.showResult);
  const showWelcomeScreen = useSelector((state: any) => state.pdEvent.showWelcomeScreen);

  const handleCalculatePD = (res: any) => {
    // console.log("camView")
    //disPatch(setShowResult(false))
    doRefresh(prev => prev + 1)
  }

  const recalculateClick = () => {
    setCpKey(prev => prev + 1)
  }

  const handleRecalculate = useCallback(() => {
    // console.log("handleRecalculate")
  }, [cpKey])

  const handleUseThisPD = () => {
    dispatch(setUseThisPD(true));
    dispatch(setShowWelcomeScreen(true));
    updateVisibility(false);
    setCpKey(prev => prev + 1)
  }

  useEffect(() => {
    if (isVisible === true) {
      //dispatch(setShowWelcomeScreen(true))


    }

    if (isVisible === false) {
      setIsPlaying(() => false)
      //setIsEnded(() => false)
      //setIsEnded(() => localStorage.getItem('pdVideoWatched') === 'true')
      setIsEnded(() => localStorage.getItem('pdVideoWatched') === 'true')
      setIsMuted(() => false)
      //videoPlayer?.current.volume = 1;

    }

    //dispatch(setUseThisPD(false));
    setCpKey(prev => prev + 1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVisible])


  const videoUrl = router.locale == 'ca' ? 'https://cdn.dresden.vision/video/PD-Video-ca.mp4' : 'https://cdn.dresden.vision/video/PD-Video-au.mp4'
  const videoPlayer = useRef<any>(null);

  const [isPlaying, setIsPlaying] = useState(false);
  const [isEnded, setIsEnded] = useState(localStorage.getItem('pdVideoWatched') === 'true');
  const [isMuted, setIsMuted] = useState(false);
  const [isTermsVisible, setIsTermsVisible] = useState(false);

  videoPlayer.current?.addEventListener('ended', () => {
    setIsPlaying(() => false)
    setIsEnded(() => true)
    localStorage.setItem('pdVideoWatched', 'true');
    setIsMuted(() => false)
    videoPlayer.current.volume = 1;
  })

  videoPlayer.current?.addEventListener('play', () => {

  });


  const startPDMeter = () => {
    setIsTermsVisible(false);
    setTimeout(() => {
      videoPlayer.current.play();
      setIsPlaying(() => true);
    }, 150);
  }

  return (
    <UIModal
      isVisible={isVisible}
      onToggleVisibility={updateVisibility}
      modalCardClassName="max-w-[947px]"
      closeable={!lockModal}>

      {(showWelcomeScreen && isTermsVisible) && <PDTermsAndConditions setIsTermsVisible={setIsTermsVisible} startPDMeter={startPDMeter} />}
      {(showWelcomeScreen && !isTermsVisible) && <div className="absolute h-full w-full z-40 bg-white px-32 py-20 flex flex-col justify-between">
        {(!isPlaying && !isEnded) && <div className="z-20 w-[700px] h-[375px] bg-[#CFD1FF] rounded-xl text-center">
          <div className=" text-4xl font-semibold text-[#6064AF] py-10">Pupil Distance Calculator</div>
          <div className=" px-10 py-10 bg-white max-w-[375px] mx-auto rounded-xl drop-shadow-md ">
            <span className='text-xl'>Ready to measure your PD?</span>
            <UIButton className='mx-auto mt-8' onClick={() => {
              videoPlayer.current.play();
              setIsPlaying(() => true);

            }}>Let’s get you started</UIButton>
          </div>
          <div className="mt-3 cursor-pointer text-brand-black100 font-medium leading-10">
            <a target="_blank" rel="noreferrer" href={'/our-glasses/measure-your-pd'}><span><Measure color="black" className="inline-block mr-2 -mt-0.5" /> How to measure your PD manually</span></a>
          </div>

          <div className="mt-[65px] cursor-pointer flex gap-[6px] items-center justify-center" onClick={() => {
            setIsTermsVisible(true);
          }}>
            <div className='mt-[2px]'>
              <InfoIcon />
            </div>
            <p className='text-[14px] text-[#616161] font-normal'>Terms and Conditions</p>
          </div>
        </div>}

        {(!isPlaying && isEnded) && <div className="z-20 w-[700px] h-[375px] bg-[#CFD1FF] rounded-xl text-center">
          <div className=" text-4xl font-semibold text-[#6064AF] py-10">Pupil Distance Calculator</div>
          <div className=" px-10 py-5 bg-white max-w-[375px] mx-auto rounded-xl drop-shadow-md ">
            <span className='text-xl'>Press start to begin now</span>
            <UIButton className='mx-auto mt-8' onClick={() => {
              //videoPlayer.current.play();
              dispatch(setShowWelcomeScreen(false))
              setIsEnded(() => false)
            }}>Start Now</UIButton>
            <div className='mt-3 text-brand-blue25 text-base cursor-pointer' onClick={() => {
              videoPlayer.current.currentTime = 0;
              videoPlayer.current.play();
              setIsPlaying(() => true);
              setIsEnded(() => false);
            }}>Replay the instructions</div>
          </div>
          <div className="cursor-pointer mt-4 text-brand-black100 font-medium leading-10">
            <a target="_blank" rel="noreferrer" href={'/our-glasses/measure-your-pd'}><span><Measure color="black" className="inline-block mr-2 -mt-0.5" /> How to measure your PD manually</span></a>
          </div>

          <div className="mt-[65px] cursor-pointer flex gap-[6px] items-center justify-center" onClick={() => {
            setIsTermsVisible(true);
          }}>
            <div className='mt-[2px]'>
              <InfoIcon />
            </div>
            <p className='text-[14px] text-[#616161] font-normal'>Terms and Conditions</p>
          </div>
        </div>}

        <video ref={videoPlayer} className={cx('z-0 min-w-[700px] min-h-[375px]', { 'hidden': !isPlaying })} src={videoUrl} ></video>
        {isPlaying && <div className=" float-right"><div className='mt-4 text-center relative'>
          <span className="cursor-pointer" onClick={() => {
            setIsEnded(() => true)
            localStorage.setItem('pdVideoWatched', 'true');
            setIsPlaying(() => false)
            videoPlayer.current.pause();
          }}>Skip the instructions</span>
          <div className="absolute inline-block  right-1 top-1 cursor-pointer mr-4 w-4" onClick={() => {
            if (videoPlayer.current.volume != 0) {
              videoPlayer.current.volume = 0
              setIsMuted(() => true)
            }
            else {
              videoPlayer.current.volume = 1
              setIsMuted(() => false)
            }
          }}>
            {!isMuted && <Mute />}
            {isMuted && <UnMute />}
          </div>
        </div>
        </div>}
      </div>}

      {!isTermsVisible && (
        <div className="grid grid-cols-[545px,auto]">
          <div className="h-[545px] relative overflow-hidden">
            {(!showWelcomeScreen && showResult) && <div className="absolute shadow flex items-center flex-col left-0 right-0 mt-10 h-28 mx-auto w-80 bg-[#FFC728] rounded z-20 text-center">
              <div className="p-4 m-2 mt-5 border-2 border-white rounded-full"><Tick /></div>
              <span className="text-lg">{`Your PD:`} <span className="font-medium">{calculatedPd}</span></span>
            </div>}

            {!showWelcomeScreen && <PDCameraView
              updateLockModal={updateLockModal}
              handleRecalculate={handleRecalculate}
              deviceType="desktop"
              visible={isVisible}
              hideOverlay={() => updateVisibility(false)}
              refresh={refresh}
            />}
          </div>
          <div className="flex flex-col justify-between">
            <div className="flex flex-col p-[24px] h-full">
              <div className="mb-[18px]">
                <span className="mb-[14px] text-[20px] font-medium text-brand-black100">
                  {title}
                </span>
              </div>
              <div className="mb-[20px]">
                {!showResult && <div id="step1">
                  <div className="text-sm">Find your PD in 5 simple steps.</div>

                  <ul className='mt-2 leading-10'>
                    <li className="flex mt-2 mb-2">
                      <div style={{ minWidth: '25px' }} className="mt-3 w-6 block h-6">
                        {!showWelcomeScreen && localStorage.getItem('cameraPermission') && <Checkmark />}
                        {showWelcomeScreen && <div className="w-7 h-7 border-2 border-brand-grey500 text-brand-blue25 font-medium leading-6 text-center rounded-full -mt-1">1</div>}
                      </div> <span className="ml-4 mt-0.5">Give Dresden access to your camera</span>
                    </li>
                    <li className="flex mt-2 mb-2">
                      <div style={{ minWidth: '25px' }} className="mt-3 w-6 block h-6">
                        {(!showWelcomeScreen && !isTooFar) && <Checkmark />}
                        {showWelcomeScreen && <div className="w-7 h-7 border-2 border-brand-grey500 text-brand-blue25 font-medium leading-6 text-center rounded-full -mt-1">2</div>}
                      </div> <span className="ml-4 mt-2.5 leading-6">Make sure you have an arm’s length distance between you and the camera </span>
                    </li>
                    <li className="flex mt-2 mb-2">
                      <div style={{ minWidth: '25px' }} className="mt-3 w-6 block h-6">
                        {(straight && !showWelcomeScreen) && <Spinner fill='#FF8200' />}
                        {(!isTooFar && !straight && !showWelcomeScreen) && <Checkmark />}
                        {showWelcomeScreen && <div className="w-7 h-7 border-2 border-brand-grey500 text-brand-blue25 font-medium leading-6 text-center rounded-full -mt-1">3</div>}
                      </div> <span className="ml-4 leading-6 mt-2.5">Centre your face within the circle until it turns green</span>
                    </li>

                    <li className="flex mt-2 mb-2">
                      <div style={{ minWidth: '25px' }} className="mt-3 w-6 block h-6">
                        {(!showWelcomeScreen) && <Spinner fill='#FF8200' />}
                        {showWelcomeScreen && <div className="w-7 h-7 border-2 border-brand-grey500 text-brand-blue25 font-medium leading-6 text-center rounded-full -mt-1">4</div>}
                      </div> <span className="ml-4 ">Take off you glasses (if any)</span>
                    </li>

                    <li className="flex mt-2 mb-2">
                      <div style={{ minWidth: '25px' }} className="mt-3 w-6 block h-6">
                        {((!isTooFar && straight || isCalculating) && !showWelcomeScreen) && <Spinner fill='#FF8200' />}
                        {showWelcomeScreen && <div className="w-7 h-7 border-2 border-brand-grey500 text-brand-blue25 font-medium leading-6 text-center rounded-full -mt-1">5</div>}
                      </div> <span className="ml-4 leading-6 mt-2.5">Look straight at the camera for 3 seconds</span>
                    </li>
                  </ul>

                  {showWelcomeScreen && <><UIButton className="min-w-full mt-8" onClick={() => {
                    dispatch(setShowWelcomeScreen(false))
                  }}>Start Now</UIButton>
                  </>}
                </div>}
                {
                  (showResult) && <div className='flex flex-col'>
                    <div className=" flex-1 text-xl mb-2">Your PD: <span className="font-medium text-brand-green">{`${calculatedPd}`}</span></div>
                    <div className=" flex-1 text-xl mb-8">Recommended Frame Size: <span className="font-medium text-brand-green">{`${headSize}`}</span></div>
                    <UIButton className="min-w-full mb-4" onClick={handleUseThisPD}>Use this PD</UIButton>
                    {/*<UIButton className="min-w-full" light={true} onClick={recalculateClick}>Recalculate</UIButton>*/}
                  </div>

                }
              </div>
              <div className="mt-auto cursor-pointer text-brand-black100 font-medium">
                <a onClick={() => {
                  dispatch(setShowWelcomeScreen(true))

                  setIsPlaying(() => true);
                  setIsEnded(() => false);
                  setTimeout(() => {
                    videoPlayer.current.currentTime = 0;
                    videoPlayer.current.play();
                  }, 500)
                }}><span className='flex mb-2'><PlayCircleIcon className='mr-2' /> Play the instructions</span></a>
                <a target="_blank" rel="noreferrer" href={'/our-glasses/measure-your-pd'}><span><Measure className="inline-block mr-2 -mt-0.5" /> How to measure your PD manually</span></a>
              </div>
            </div>

          </div>
        </div>)}
    </UIModal >
  );
};

const PDDesktopBuySection: FC<{
  minPrice: number;
  title: string;
  onClick?: () => void;
  loading: boolean;
}> = ({ minPrice, title, onClick, loading }) => {
  return (
    <div className="bg-white px-[24px] py-[20px] shadow-top">
      <div className="flex items-center justify-between">
        <div className="flex flex-col">
          <span className="mb-[4px] text-[14px] text-brand-grey450">
            {title}
          </span>
          <span className="text-[18px] font-medium text-brand-black100">
            From ${minPrice}
          </span>
        </div>
        <div>
          <UIButton loading={loading} block onClick={() => onClick?.()}>
            View Product
          </UIButton>
        </div>
      </div>
    </div>
  );
};

const PDMobilePartSelect: FC<{
  title: string;
  subTitle?: string;
  selected: boolean;
  toggle?: () => void;
}> = ({ title, subTitle, selected, toggle }) => {
  return (
    <div
      onClick={() => toggle?.()}
      className={cx(
        'inline-flex min-h-[40px] flex-col items-center justify-center rounded-[100px] px-[19px] transition-colors',
        {
          'bg-white bg-opacity-90 text-brand-black100': !selected,
          'bg-opactity-100 bg-brand-orange text-white': selected
        }
      )}>
      <span className="text-[14px] font-medium leading-[12px]">{title}</span>
      <span
        className={cx('text-[10px] font-medium', {
          'text-brand-grey450': !selected
        })}>
        {subTitle}
      </span>
    </div>
  );
};



const PDMobilePriceSection: FC<{
  title: string;
  minPrice: number;
  onClick?: () => void;
}> = ({ title, minPrice, onClick }) => {
  return (
    <div className="grid grid-cols-[1fr,auto] gap-[12px] pr-[12px]">
      <div className="flex flex-col overflow-hidden text-white">
        <span className="mb-[4px] block overflow-hidden overflow-ellipsis whitespace-nowrap font-medium">
          {title}
        </span>
        <span>From ${minPrice}</span>
      </div>
      <div>
        <UIButton onClick={() => onClick?.()}>View Product</UIButton>
      </div>
    </div>
  );
};

const PDMobileOverlay: FC<PDOverlayProps> = ({
  isVisible,
  updateVisibility,
  title,
  lockModal,
  updateLockModal,

}) => {
  const [isCameraViewReady, setIsCameraViewReady] = useState(false);
  const [selectedPart, setSelectedPart] = useState<'frame' | 'arm' | 'lens'>(
    'frame'
  );

  const { width, height } = useWindowSize();

  const [refresh, doRefresh] = useState(0);

  const scrollWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!scrollWrapperRef.current) return;

    scrollWrapperRef.current?.scrollTo?.(0, 0);
  }, [scrollWrapperRef, selectedPart]);

  const [cpKey, setCpKey] = useState(0);
  const showResult = useSelector((state: any) => state.pdEvent.showResult);
  const dispatch = useDispatch()
  const cam = useRef()
  const [isCalculating, setIsCalculating] = useState(false);


  const handleCalculatePD = (res: any) => {
    // console.log("camView")
    //disPatch(setShowResult(false))
    doRefresh(prev => prev + 1)
  }

  const recalculateClick = () => {
    setCpKey(prev => prev + 1)
  }

  const handleRecalculate = useCallback(() => {
    // console.log("handleRecalculate")
  }, [cpKey])

  const calculatedPd = useSelector((state: any) => state.pdEvent.calculatedPd);
  const centerToIris = useSelector((state: any) => state.pdEvent.centerToIris);
  const headSize = useSelector((state: any) => state.pdEvent.headSize);
  const isTooFar = useSelector((state: any) => state.pdEvent.faceIsTooFar)
  const straight = useSelector((state: any) => state.pdEvent.faceIsStraight);
  const showWelcomeScreen = useSelector((state: any) => state.pdEvent.showWelcomeScreen);

  const handleUseThisPD = () => {
    dispatch(setUseThisPD(true));
    updateVisibility(false);
  }

  useEffect(() => {
    if (isTooFar == false && straight == true) {
      setIsCalculating(true);
      setTimeout(() => {
        //setShowResult(true)
        setIsCalculating(false)
      }, 3000);
    }
  }, [isTooFar, straight])

  useEffect(() => {
    setCpKey(prev => prev + 1)
    //setInstructionStep(0)

    if (isVisible === false) {
      setIsPlaying(() => false)
      setIsEnded(() => localStorage.getItem('pdVideoWatched') === 'true')
      //setIsEnded(() => false)
      setIsMuted(() => false)
      //videoPlayer?.current.volume = 1;
    }
  }, [isVisible])

  const [instructionStep, setInstructionStep] = useState(0)

  const videoUrl = router.locale == 'ca' ? 'https://cdn.dresden.vision/video/PD-Video-mobile-ca.mp4' : 'https://cdn.dresden.vision/video/PD-Video-mobile-au.mp4'
  const videoPlayer = useRef<any>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isEnded, setIsEnded] = useState(localStorage.getItem('pdVideoWatched') === 'true');
  const [isMuted, setIsMuted] = useState(false);
  const [isTermsVisible, setIsTermsVisible] = useState(false);

  videoPlayer.current?.addEventListener('ended', () => {
    setIsPlaying(() => false)
    setIsEnded(() => true)
    localStorage.setItem('pdVideoWatched', 'true');
    setIsMuted(() => false)
    videoPlayer.current.volume = 1;
  })

  videoPlayer.current?.addEventListener('play', () => {

  })


  const startPDMeter = () => {
    setIsTermsVisible(false);
    setTimeout(() => {
      videoPlayer.current.play();
      setIsPlaying(() => true);
    }, 150);
  }

  return (
    <UIMobileFullscreenOverlay
      isVisible={isVisible}
      onToggleVisibility={updateVisibility}
      className="max-w-[947px]"
      closeable={!lockModal}>
      <div className="mb-[20px] absolute z-20 w-full h-full text-center text-white">
        {width > height && <div className='z-20 absolute bg-[#00000040] w-full top-0 left-0 h-full items-center flex'>
          <div className='p-8 rounded w-72 mx-auto bg-white text-black text-base font-medium'>
            <DeviceRotate className='mx-auto mb-4 ' />
            Rotate your device to portrait</div>
        </div>}

        {isTermsVisible && <PDTermsAndConditions setIsTermsVisible={setIsTermsVisible} startPDMeter={startPDMeter} />}
        {(showWelcomeScreen && !isTermsVisible) && <div className="absolute h-full w-full z-50 bg-white flex flex-col justify-between">
          {(!isPlaying && !isEnded) && <div className="z-20 px-6 mx-auto my-20 w-[310px] h-[524px] bg-[#CFD1FF] rounded-xl text-center">
            <div className=" text-4xl font-semibold text-[#6064AF] py-10">Pupil Distance Calculator</div>
            <div className=" px-4 py-10 bg-white text-black max-w-[270px] mx-auto rounded-xl drop-shadow-md ">
              <span className='text-lg'>Ready to measure your PD?</span>
              <UIButton className='mx-auto mt-8' onClick={() => {
                videoPlayer.current.play();
                setIsPlaying(() => true)
              }}>Let’s get you started</UIButton>
            </div>
            <div className="mt-3 cursor-pointer text-brand-black100 font-medium">
              <a target="_blank" rel="noreferrer" href={'/our-glasses/measure-your-pd'}><span><Measure color="black" className="inline-block mr-2 -mt-0.5" /> How to measure your PD manually</span></a>
            </div>

            <div className="mt-[65px] cursor-pointer flex gap-[6px] items-center justify-center absolute bottom-2 left-1/2 transform -translate-x-1/2" onClick={() => {
              setIsTermsVisible(true);
            }}>
              <div className='mt-[2px]'>
                <InfoIcon />
              </div>
              <p className='text-[14px] text-[#616161] font-normal'>Terms and Conditions</p>
            </div>
          </div>}

          {(!isPlaying && isEnded && !isTermsVisible) && <div className="z-20 w-[310px] h-[524px] mx-auto my-16 bg-[#CFD1FF] rounded-xl text-center">
            <div className=" text-4xl font-semibold text-[#6064AF] py-10">Pupil Distance Calculator</div>
            <div className="px-4 py-6 bg-white text-black max-w-[270px] mx-auto rounded-xl drop-shadow-md ">
              <span className='text-xl text-black'>Press start to begin now</span>
              <UIButton className='mx-auto mt-8' onClick={() => {
                //videoPlayer.current.play();
                dispatch(setShowWelcomeScreen(false))
                setIsEnded(() => false)
              }}>Start Now</UIButton>
              <div className='mt-4 text-brand-blue25 text-base cursor-pointer' onClick={() => {
                videoPlayer.current.currentTime = 0;
                videoPlayer.current.play();
                setIsPlaying(() => true);
                setIsEnded(() => false);
              }}>Replay the instructions</div>
            </div>
            <div className="mt-3 cursor-pointer text-brand-black100 font-medium">
              <a target="_blank" rel="noreferrer" href={'/our-glasses/measure-your-pd'}><span><Measure color="black" className="inline-block mr-2 -mt-0.5" /> How to measure your PD manually</span></a>
            </div>

            <div className="mt-[65px] cursor-pointer flex gap-[6px] items-center justify-center absolute bottom-2 left-1/2 transform -translate-x-1/2" onClick={() => {
              setIsTermsVisible(true);
            }}>
              <div className='mt-[2px]'>
                <InfoIcon />
              </div>
              <p className='text-[14px] text-[#616161] font-normal'>Terms and Conditions</p>
            </div>
          </div>}
          <span className="relative max-w-xs text-black mx-auto">
            {<video ref={videoPlayer} className={cx('z-0 rounded-xl w-[310px] mx-auto my-16 mb-2 min-h-[524px]', { 'hidden': !isPlaying })} src={videoUrl} ></video>}
            {isPlaying && <div><div className='mt-2 text-center relative'>
              <span className="cursor-pointer" onClick={() => {
                setIsEnded(() => true)
                localStorage.setItem('pdVideoWatched', 'true');
                setIsPlaying(() => false)
                videoPlayer.current.pause();
              }}>Skip the instructions</span>
              <div className="right-1 absolute top-1 float-right cursor-pointer mr-4 w-4" onClick={(e) => {
                if (videoPlayer.current.volume != 0) {
                  videoPlayer.current.volume = 0
                  setIsMuted(() => true)
                } else {
                  videoPlayer.current.volume = 1
                  setIsMuted(() => false)
                }
              }}>
                {!isMuted && <Mute />}
                {isMuted && <UnMute />}
              </div>
            </div>
            </div>}
          </span>
        </div>}


        {(showResult) && <div className='flex flex-col h-full relative'>
          <div className=" flex-1 text-xl mb-8 w-full">
            <div className="bg-[#FFC728] text-brand-black100 shadow items-center absolute w-80 left-0 right-0 mx-auto p-4 mt-10 rounded text-center"><div className="p-4 m-2 mt-5 border-2 border-white rounded-full inline-block h-full"><Tick /></div>
              <div>Your PD: <span className="font-medium">{`${calculatedPd}`}</span></div>
              <div>Frame Size: <span className="font-medium text-brand-green">{`${headSize}`}</span></div>
            </div>
            <UIButton className="min-w-full absolute bottom-1 mt-4 font-medium text-sm" onClick={handleUseThisPD} light={true}>Use this PD</UIButton>
          </div>
          {/*<UIButton className="min-w-full" light={true} onClick={recalculateClick}>Recalculate</UIButton>*/}
        </div>
        }
      </div>

      {!isTermsVisible && (
        <div className="PD-mobile-overlay absolute h-full w-full bg-brand-black100">
          <PDCameraView
            updateLockModal={updateLockModal}
            onReady={() => setIsCameraViewReady(true)}
            hideOverlay={() => updateVisibility(false)}
            handleRecalculate={handleRecalculate}
            deviceType="mobile"
            visible={isVisible}
            refresh={refresh}
          />
        </div>)}
    </UIMobileFullscreenOverlay >
  );
};

export default PDModal;
